import { Injectable } from '@angular/core';
import { CreateSalesOrderPayload } from './sales-order';
import { StorageService } from './storage';

export enum SalesOrderState {
  DRAFT = 'draft', // initial state, not yet sent to the server
  SENT = 'sent', // sent to the server, but not confirmed
  DONE = 'done', // confirmed and completed
  CANCELLED = 'cancelled' // cancelled by the user or system
}
export interface PendingSalesOrder {
  state: SalesOrderState;
  salesOrder: CreateSalesOrderPayload;
}
@Injectable({
  providedIn: 'root'
})
export class PendingOrderService extends StorageService<PendingSalesOrder> {
  private dbName = 'cart';
  private storeName = 'pendingOrders';

  async savePendingOrder(order: CreateSalesOrderPayload, state: SalesOrderState): Promise<void> {
    const orders = await this.getAll(this.dbName, this.storeName);
    orders.push({ state, salesOrder: order });
    await this.putAll(this.dbName, this.storeName, orders);
  }

  async getPendingOrders(): Promise<PendingSalesOrder[]> {
    return await this.getAll(this.dbName, this.storeName);
  }

  async clearPendingOrders(): Promise<void> {
    await this.clearStore(this.dbName, this.storeName);
  }

  async updatePendingOrders(updatedOrders: PendingSalesOrder[]): Promise<void> {
    await this.putAll(this.dbName, this.storeName, updatedOrders);
  }

  async removePendingOrder(idempotencyKey: string): Promise<void> {
    const current = await this.getAll(this.dbName, this.storeName);
    const updated = current.filter(o => o.salesOrder.idempotencyKey !== idempotencyKey);
    await this.putAll(this.dbName, this.storeName, updated);
  }

  async updatePendingOrder(updatedOrder: PendingSalesOrder): Promise<void> {
    const current = await this.getAll(this.dbName, this.storeName);
    const updated = current.map(order => {
      if (order.salesOrder.idempotencyKey === updatedOrder.salesOrder.idempotencyKey) {
        return updatedOrder;
      }
      return order;
    });
    await this.putAll(this.dbName, this.storeName, updated);
  }
}
